// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UWAC9","productName":"Table_productName__3FdK5"};